/**
 * Where the game is running. The Android APK is a Capacitor shell that
 * injects `window.Capacitor`; the web build never imports native plugins.
 */
interface CapacitorGlobal {
  isNativePlatform?: () => boolean;
  getPlatform?: () => string;
}

function capacitor(): CapacitorGlobal | undefined {
  return typeof window === "undefined" ? undefined : (window as unknown as { Capacitor?: CapacitorGlobal }).Capacitor;
}

export function isNativeApp(): boolean {
  return capacitor()?.isNativePlatform?.() === true;
}

export function isIOS(): boolean {
  if (typeof navigator === "undefined") return false;
  const ua = navigator.userAgent;
  // iPadOS reports a Mac user agent but has touch.
  return /iPhone|iPad|iPod/.test(ua) || (/Macintosh/.test(ua) && navigator.maxTouchPoints > 1);
}

export function isAndroidWeb(): boolean {
  return typeof navigator !== "undefined" && /Android/i.test(navigator.userAgent) && !isNativeApp();
}

/** Launched from the home screen (PWA) rather than a browser tab. */
export function isStandalone(): boolean {
  if (typeof window === "undefined") return false;
  const nav = navigator as Navigator & { standalone?: boolean };
  return nav.standalone === true || window.matchMedia?.("(display-mode: standalone)").matches === true;
}

/** Test switches for desktop previews: ?platform=ios or ?platform=android. */
export function forcedPlatform(): "ios" | "android" | null {
  if (typeof location === "undefined") return null;
  const value = new URLSearchParams(location.search).get("platform");
  return value === "ios" || value === "android" ? value : null;
}

export const platform = {
  ios: () => forcedPlatform() === "ios" || isIOS(),
  androidWeb: () => forcedPlatform() === "android" || isAndroidWeb(),
  native: isNativeApp,
  standalone: isStandalone,
};
